import classes from './ReviewStarsWithCounter.module.scss'
import ReviewStars from '../ReviewStars/ReviewStars'

const ReviewStarsWithCounter = ({ rating, numberOfReviews, maxWidth = 70 }) => {
  return (
    <span className={classes['review-stars-link']}>
      <ReviewStars rating={rating} maxWidth={maxWidth} />
      {numberOfReviews > 100 ? `${numberOfReviews} Reviews` : ``}
    </span>
  )
}

export default ReviewStarsWithCounter
